<template>
  <div id="geobeta">
    <Greet @show-modal="onShowModal" />
    <ThisIsGeobeta />
    <Features />
    <WorkInProgress />
    <Screenshots @show-modal="onShowModal" />
    <WhyNotBeta />
    <div class="button-wrapper">
      <router-link :to="{ name: FAQ_PAGE_NAME }">
        <button class="butn butn--red butn--sm button__faq">
          Still have questions? Check FAQ
        </button>
      </router-link>
    </div>

    <Modal ref="screenshotModal">
      <template v-slot:body>
        <img v-if="!isVideo" :src="getImgUrl()" />
        <iframe
          v-else
          id="ytplayer"
          loading="lazy"
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/mjEB32cQz-k?autoplay=0&mute=0"
          frameborder="0"
        ></iframe>
      </template>
      >
    </Modal>
  </div>
</template>

<script>
import Greet from "./../partials/geobeta/Greet";
import ThisIsGeobeta from "./../partials/geobeta/ThisIsGeobeta";
import Screenshots from "./../partials/geobeta/Screenshots";
import WorkInProgress from "./../partials/geobeta/WorkInProgress";
import Features from "./../partials/geobeta/Features";
import WhyNotBeta from "./../partials/geobeta/WhyNotBeta";

import { FAQ_PAGE_NAME } from "./../../router/names";

export default {
  name: "Geobeta",
  components: {
    Modal: () => import("./../partials/common/Modal"),
    Greet,
    ThisIsGeobeta,
    Screenshots,
    WorkInProgress,
    Features,
    WhyNotBeta,
  },
  data() {
    return {
      FAQ_PAGE_NAME,
      isModalVisible: false,
      modalScreenNum: null,
      isVideo: false,
    };
  },
  computed: {},
  methods: {
    getImgUrl() {
      if (this.modalScreenNum === 1) {
        this.isVideo = false;
        return require(`../../../public/static/img/geobeta/screenshots/mini-dayz-2-${1}.jpg`);
      } else if (this.modalScreenNum === 2) {
        this.isVideo = false;
        return require(`../../../public/static/img/geobeta/screenshots/mini-dayz-2-${2}.jpg`);
      } else if (this.modalScreenNum === 3) {
        this.isVideo = false;
        return require(`../../../public/static/img/geobeta/screenshots/mini-dayz-2-${3}.jpg`);
      } else {
        this.isVideo = true;
        return "https://www.youtube.com/watch?v=4uA5u-tpVaQ&feature=emb_title";
      }
    },
    onShowModal(screenNum) {
      this.modalScreenNum = screenNum;
      this.getImgUrl(screenNum);
      this.$refs.screenshotModal.openModal();
      this.isModalVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  justify-content: center;
  padding-bottom: 7em;
}
</style>
